import type { ICartUpdateDto } from '#shared/api';
import type { ICartCRUDItem } from '../models';

export function getCartUpdateDto(productDTO: ICartCRUDItem[]) {
  const dto: ICartUpdateDto = { items: [] };

  productDTO.forEach((it) => {
    if (!it.product.skuId) return;

    dto.items.push({
      goodId: it.product.skuId,
      offerId: it.product.skuId,
      qnty: it.qnty,
      selected: it.selected,
    });
  });

  return dto;
}
